import React, { useState } from "react"; 
import { Link } from "react-router-dom";
import "./Nav.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
  // Add this state declaration
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse) {
      if (!isMenuOpen) {
        navbarCollapse.classList.add('show');
      } else {
        navbarCollapse.classList.remove('show');
      }
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse) {
      navbarCollapse.classList.remove('show');
    }
  };

  return (
    <>
      <style>
        {`
          /* Only toggle icon styling - no UI/Logic changes */
          @media (max-width: 992px) {
            .navbar-toggler {
              border: 2px solid #0462c7 !important;
              background: white !important;
              padding: 8px 12px !important;
              border-radius: 8px !important;
              display: flex !important;
              align-items: center;
              justify-content: center;
            }
            
            .navbar-toggler:focus {
              outline: none;
              box-shadow: 0 0 0 3px rgba(4, 98, 199, 0.2);
            }
            
            /* Hide the default toggler icon */
            .navbar-toggler-icon {
              display: none !important;
            }
          }
        `}
      </style>
      
      <div className="navbar navbar-expand-lg fixed-top custom-navbar">
        <div className="container ">
          <Link className="nav-item" to="/" onClick={closeMenu}>
            <img
              src="img/CompanyLogo3.png"
              className="fs-1 color-primary"
              width={120}
              alt="Company Logo"
            />
          </Link>

          <button
            className="navbar-toggler btn btn-outline-dark"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} style={{ color: '#0462c7', fontSize: '22px' }} />
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link active mx-2" to="/" onClick={closeMenu}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link mx-2" to="/about" onClick={closeMenu}>
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link mx-2" to="/industries" onClick={closeMenu}>
                  Industries
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link mx-2" to="/career" onClick={closeMenu}>
                  Career
                </Link>
              </li>
              
              <li className="nav-item dropdown" 
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onMouseLeave={() => setIsDropdownOpen(false)}>
                <button
                  className="nav-link dropdown-toggle mx-2"
                  type="button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  style={{ background: 'none', border: 'none' }}
                >
                  Services <FontAwesomeIcon icon={faChevronDown} className="ms-1" />
                </button>
                <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`} 
                    style={{ display: isDropdownOpen ? 'block' : 'none' }}>
                  <li><Link className="dropdown-item" to="/businessconsulting" onClick={closeMenu}>Business Consulting</Link></li>
                  <li><Link className="dropdown-item" to="/consulting" onClick={closeMenu}>ERP Consulting</Link></li>
                  <li><Link className="dropdown-item" to="/ERPimplementation" onClick={closeMenu}>ERP Implementation</Link></li>
                  <li><Link className="dropdown-item" to="/appdevelopment" onClick={closeMenu}>Mobile Development</Link></li>
                  <li><Link className="dropdown-item" to="/productdevelopment" onClick={closeMenu}>Product Development</Link></li>
                  <li><Link className="dropdown-item" to="/WebDevelopment" onClick={closeMenu}>Web Development</Link></li>
                </ul>
              </li>
              
              <li className="nav-item">
                <Link className="btn btn-primary contact-btn mx-2" to="/contact" onClick={closeMenu}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;